import { Translation } from "@shared/types/translation";
import { useLocale } from "@translations/locale-context";
import { Button } from "@ui/components/button/button";
import { Icon } from "@ui/components/icon/icon";
import jump from "jump.js";
import Image from "next/legacy/image";
import React from "react";

const HERO: Translation[] = [
    {
        cs: "Zvýšení konverzního poměru",
        en: "Increase conversion rate",
    },
    {
        cs: "Detailní analýza použitelnosti existujícího rozhraní",
        en: "Detailed usability analysis of the existing interface",
    },
    {
        cs: "Návrhy a\u00a0doporučení změn v\u00a0kontextu vašeho byznysu",
        en: "Suggestions for changes in the context of your business",
    },
    {
        cs: "Analýza konkurence pro srovnání na\u00a0trhu",
        en: "Competition analysis for market comparison",
    },
    {
        cs: "Prioritizace kroků a\u00a0plán jak změny implementovat",
        en: "Prioritization of steps and plan how to implement changes",
    },
];

export const AuditHeroSection = () => {
    const handleClick = () => {
        jump(".audit-packages");
    };
    const locale: "cs" | "en" = useLocale();
    const eng =
        "UX audit of the website, e-shop or mobile app with regard to minimizing the risk of inefficient investments";
    const cz = "UX audit webu, e-shopu nebo aplikace s\u00a0cílem minimalizace rizika neefektivních investic";
    const buttonEn = "Request a Quote";
    const buttonCs = "Nezávazně poptat";

    return (
        <div className="bg-[#F8F8F7] px-5 max-md:relative md:px-0">
            <div className="md:container md:relative">
                <div className="relative z-1 pb-10 pt-5 max-md:container lg:py-24">
                    <h1 className="max-w-[790px] pb-8 text-medium font-bold text-uxfViolet sm:text-h5 xl:text-h4">
                        {locale === "en" ? eng : cz}
                    </h1>
                    <ul className="space-y-2 pb-12">
                        {HERO.map(({ cs, en }, index) => (
                            <li className="flex" key={index}>
                                <div className="pr-4 text-uxfGreen">
                                    <Icon name="checkSimple" />
                                </div>
                                {[locale === "en" ? en : cs]}
                            </li>
                        ))}
                    </ul>
                    <Button size="small" variant="orange" onClick={handleClick}>
                        <p className="px-7">{locale === "en" ? buttonEn : buttonCs}</p>
                    </Button>
                </div>
                <div className="absolute inset-y-0 -right-44 size-full max-w-[1200px] max-lg:opacity-25 max-md:hidden">
                    <Image
                        src="/static/landing-pages/audit-hero.png"
                        objectFit="contain"
                        layout="fill"
                        width={1437}
                        height={823}
                        alt={locale === "en" ? "Woman drawing UX design" : "Žena kreslící UX design"}
                    />
                </div>
                <div className="absolute inset-y-0 right-0 size-full opacity-25 md:hidden">
                    <Image
                        src="/static/landing-pages/audit-hero.png"
                        objectFit="cover"
                        layout="fill"
                        width={1437}
                        height={823}
                        alt={locale === "en" ? "Woman drawing UX design" : "Žena kreslící UX design"}
                    />
                </div>
            </div>
        </div>
    );
};
